import trialManagementStore from './store';

import { preferencesConfigAction } from './actions';

const trialManagementActions = {
  preferencesConfigAction,
};

export { trialManagementStore, trialManagementActions };
